import { UseFormReturn } from "react-hook-form";
import { MiDetailFields } from "@miplatform/components";
import { ConfigAccordionHeader } from "../../../components/ConfigAccordionHeader/ConfigAccordionHeader";
import { IRoleFormData } from "../../ConfigRoles.types";

interface RoleDetailsTabProps {
  form: UseFormReturn<IRoleFormData>;
  extraTabProps?: {
    isReadOnly?: boolean;
  };
}

export const RoleDetailsTabView = ({
  form,
  extraTabProps,
}: RoleDetailsTabProps) => {
  const { control } = form;
  const { isReadOnly } = extraTabProps || {};
  const roleDetailFields = [
    {
      label: "Role Name",
      name: "name",
      formControl: control,
      required: true,
      width: "50%",
      disabled: isReadOnly,
    },
    {
      label: "Description",
      name: "description",
      formControl: control,
      required: true,
      width: "100%",
      disabled: isReadOnly,
    },
  ];

  return (
    <ConfigAccordionHeader title="Role Details">
      <MiDetailFields detailFields={roleDetailFields} />
    </ConfigAccordionHeader>
  );
};
